var _rect, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07795 9.07795H1V1H9.07795V9.07795Z",
    fill: "#F1511B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9967 9.07795H9.91895V1H17.9967V9.07795Z",
    fill: "#80CC28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07764 17.9999H1V9.92212H9.07764V17.9999Z",
    fill: "#00ADEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9967 17.9999H9.91895V9.92212H17.9967V17.9999Z",
    fill: "#FBBC09"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOSAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHdpZHRoPSIxOSIgaGVpZ2h0PSIxOSIgLz4KICAgIDxwYXRoIGQ9Ik05LjA3Nzk1IDkuMDc3OTVIMVYxSDkuMDc3OTVWOS4wNzc5NVoiIGZpbGw9IiNGMTUxMUIiIC8+CiAgICA8cGF0aCBkPSJNMTcuOTk2NyA5LjA3Nzk1SDkuOTE4OTVWMUgxNy45OTY3VjkuMDc3OTVaIiBmaWxsPSIjODBDQzI4IiAvPgogICAgPHBhdGggZD0iTTkuMDc3NjQgMTcuOTk5OUgxVjkuOTIyMTJIOS4wNzc2NFYxNy45OTk5WiIgZmlsbD0iIzAwQURFRiIgLz4KICAgIDxwYXRoIGQ9Ik0xNy45OTY3IDE3Ljk5OTlIOS45MTg5NVY5LjkyMjEySDE3Ljk5NjdWMTcuOTk5OVoiIGZpbGw9IiNGQkJDMDkiIC8+CiAgPC9zdmc+";
export { ForwardRef as ReactComponent };